import { logout as clearAuth } from '@/store';
import { useLogoutMutation } from '@/store/api/authApi';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';

const Header: React.FC = () => {
  const [logout] = useLogoutMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout().unwrap();
      dispatch(clearAuth());
      toast.success('You have been logged out successfully.');
      navigate('/login');
    } catch (err: any) {
      console.error('Logout failed:', err);
      toast.error(err?.data?.message || 'Failed to logout. Please try again.');
    }
  };
  return (
    <header className="fixed top-0 right-0 z-[99] w-full bg-sidebar text-white flex justify-between items-center pl-0.5 pr-2 sm:px-2 xl:px-4 py-2 border-b border-border">
      {/* Left Nav */}
      <div className="flex items-center justify-center gap-x-4">
        <Link to="/">
          <img src={'/images/logo.png'} alt="" className="h-auto max-w-[140px]" />
        </Link>
      </div>

      {/* Right Section */}
      <div className="flex items-center gap-1 sm:gap-2 text-base">
        <Button onClick={handleLogout} className="bg-btn-gradient">
          Logout
        </Button>
      </div>
    </header>
  );
};

export default Header;
